module.exports = __webpack_public_path__ + "static/img/1_0013.1b356d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0013.jpg
// module id = ljHG
// module chunks = 0